import React, { useRef, useState } from "react";
import { useUscSelector } from "../../../redux/store";
import { useUscLabel } from "../../../utils/labels";
import { useCloseOnOutsideClick } from "../../../../../common-deprecated/hooks";
import TaxLocationSearch from "./TaxLocationSearch";
import { getLocationId } from "../../../utils/externalPriceUtils";
import Label from "../styles/atoms/Label";
import Selectlist from "../styles/molecules/Selectlist";
import type { UscTrackingLocation } from "../../../utils/tracking";

const TaxLocation = ({ trackingLocation }: { trackingLocation: UscTrackingLocation }): JSX.Element | null => {
    const taxLocations = useUscSelector((state) => state.uscSettings.taxLocations);
    const currentTaxLocation = useUscSelector(({ uscSettings, externalPrice, dealer }) =>
        uscSettings.taxLocations.find(
            (location) => location.id === getLocationId(dealer.dealer, externalPrice.userTaxLocationId),
        ),
    );
    const [departmentLabel, regionLabel] = useUscLabel(["uscTaxesAndCostsDepartment", "uscTaxesAndCostsSelectRegion"]);

    const [regionsVisible, setRegionsVisible] = useState<boolean>(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    useCloseOnOutsideClick(dropdownRef, () => setRegionsVisible(false), !regionsVisible);

    // Only show Tax Location dropdown when country has tax locations
    if (!taxLocations.length) return null;

    return (
        <div>
            <Label variant="form-label">{departmentLabel}</Label>
            <Selectlist
                name="select-tax-location"
                variant="selectlist-with-search"
                selectlistTitle={currentTaxLocation?.label}
                listboxHeadingTitle={regionLabel}
                show={regionsVisible}
                dropdownRef={dropdownRef}
                onClick={() => {
                    setRegionsVisible(!regionsVisible);
                }}
            >
                <TaxLocationSearch onClose={() => setRegionsVisible(false)} trackingLocation={trackingLocation} />
            </Selectlist>
        </div>
    );
};

export default TaxLocation;
